import {TYPE_CLEAR_REFRESH_CURRENT_PAGE} from "./types";

export function clearRefreshCurrentPageAction() {
	return {
		type: TYPE_CLEAR_REFRESH_CURRENT_PAGE,
	};
}
